import { Action, createReducer, on } from '@ngrx/store';
import {
    loadAgenciesFailure,
    loadAgenciesSuccess,
    loadCredentialingSpecialistsFailure,
    loadCredentialingSpecialistsSuccess,
    loadPerDiemRulesFailure,
    loadPerDiemRulesSuccess,
    loadPerDiemSpecialistsFailure,
    loadPerDiemSpecialistsSuccess,
    loadRecruitersFailure,
    loadRecruitersSuccess,
    loadSpecialistsFailure,
    loadSpecialistsSuccess,
    loadTravelSpecialistsFailure,
    loadTravelSpecialistsSuccess,
    loadTypesFailure,
    loadTypesSuccess
} from 'src/app/credentialing/+store/actions/credentialing.actions';
import { AutoAssignState } from 'src/app/credentialing/+store/state/autoassign.state';

export const credentialingFeatureKey = 'credentialing';

const initialState: AutoAssignState = {
    credentialingSpecialists: [],
    travelCredentialingSpecialists: [],
    agencies: [],
    recruiters: [],
    types: [],
    adminSpecialists: [],
    error: undefined,
    perDiemRules: [],
    perDiemSpecialists: []
};

const reducer = createReducer(
    initialState,
    on(loadAgenciesSuccess, (state, action) => ({
        ...state,
        agencies: action.agencies
    })),
    on(loadAgenciesFailure, (state, action) => ({
        ...state,
        agencies: [],
        error: action.error
    })),

    on(loadCredentialingSpecialistsSuccess, (state, action) => ({
        ...state,
        credentialingSpecialists: action.credentialingSpecialists
    })),

    on(loadCredentialingSpecialistsFailure, (state, action) => ({
        ...state,
        credentialingSpecialists: [],
        error: action.error
    })),

    on(loadRecruitersSuccess, (state, action) => ({
        ...state,
        recruiters: action.recruiters
    })),

    on(loadRecruitersFailure, (state, action) => ({
        ...state,
        recruiters: [],
        error: action.error
    })),

    on(loadTravelSpecialistsSuccess, (state, action) => ({
        ...state,
        travelCredentialingSpecialists: action.travelCredentialingSpecialists
    })),

    on(loadTravelSpecialistsFailure, (state, action) => ({
        ...state,
        travelCredentialingSpecialists: [],
        error: action.error
    })),

    on(loadTypesSuccess, (state, action) => ({
        ...state,
        types: action.types
    })),

    on(loadTypesFailure, (state, action) => ({
        ...state,
        types: [],
        error: action.error
    })),

    on(loadSpecialistsSuccess, (state, action) => ({
        ...state,
        adminSpecialists: action.adminSpecialists
    })),

    on(loadSpecialistsFailure, (state, action) => ({
        ...state,
        adminSpecialists: [],
        error: action.error
    })),
    on(loadPerDiemRulesSuccess, (state, action) => ({
        ...state,
        perDiemRules: action.perDiemRules
    })),

    on(loadPerDiemRulesFailure, (state, action) => ({
        ...state,
        perDiemRules: [],
        error: action.error
    })),

    on(loadPerDiemSpecialistsSuccess, (state, action) => ({
        ...state,
        perDiemSpecialists: action.perDiemSpecialists
    })),

    on(loadPerDiemSpecialistsFailure, (state, action) => ({
        ...state,
        perDiemSpecialists: [],
        error: action.error
    }))
);

export function autoAssignReducer(state: AutoAssignState | undefined, action: Action) {
    return reducer(state, action);
}
